export var PlanComponentCategory;
(function (PlanComponentCategory) {
    PlanComponentCategory["CutEnergyWaste"] = "cutEnergyWaste";
    PlanComponentCategory["ElectrifyMobile"] = "electrifyMobile";
    PlanComponentCategory["ElectrifyStationary"] = "electrifyStationary";
    PlanComponentCategory["BuyClean"] = "buyClean";
    PlanComponentCategory["Other"] = "other";
})(PlanComponentCategory || (PlanComponentCategory = {}));
